import { Box, Theme, Typography } from '@mui/material'
import React from 'react'
import CustomDropdown from '../../../../lib/formik/CustomDropdown'
import CustomePieChart from '../../../dashboard/chart/CustomePieChart'
import { AlternativeAssetPieChartProps } from '../../../../redux-store/types/alternative'
import { ErrorText } from '../../../dashboard/chart/CustomeLineChart'

function AlternativeAssetPieChart(props: AlternativeAssetPieChartProps) {
    const { clientCode, completeData, isLoading } = props

    const modifiedData = completeData?.result?.categoryWiseDistribution?.data?.map((item) => (
        [item[0], item[2]]
    ))

    return (
        <Box sx={(theme: Theme) => ({
            borderRadius: '20px',
            padding: '25px 30px 45px 30px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
            background: theme.palette.common.white,
            height: '100%'
        })}>
            <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Typography variant="h2" sx={{
                    marginBottom: '40px'
                }}>Asset Allocation</Typography>

            </Box>
            {!isLoading && (!completeData?.isSuccess || completeData?.result?.categoryWiseDistribution?.data.length === 0) ? <ErrorText /> :
                <CustomePieChart {...{
                    data: modifiedData,
                    isLoading: isLoading,
                    showSlider: true,
                    labelData: completeData?.result?.categoryWiseDistribution?.labelData,
                    totalValue: completeData?.result?.categoryWiseDistribution?.totalValue,
                }} />}
        </Box>
    )
}

export default AlternativeAssetPieChart